import type { ReactNode } from "react"

interface SectionShellProps {
  id: string
  section: number
  children: ReactNode
  align?: "left" | "right"
  variant?: "default" | "method"
  className?: string
}

export function SectionShell({ id, section, children, align = "left", variant = "default", className = "" }: SectionShellProps) {
  const classes = [
    "panel",
    align === "right" ? "split right" : "split",
    variant === "method" ? "method-panel" : "",
    className,
  ].filter(Boolean).join(" ")

  return (
    <section className={classes} id={id} data-section={section}>
      {children}
    </section>
  )
}
